import { dependencyInjector, $getLanguageLoader } from "shared/services";
import { ESModuleLoader, Bootstrapper } from "silver";
import { isMyonApiSuccess, MyonApiResponse } from "shared/Api/MyonApiResponse";
import { MyonEnv } from "shared/Api/MyonEnv";
import { MyonLanguageLoaderMap } from "Lang";

function isMountable(arg: any): arg is { handleMount: () => any } {
	return typeof arg === "object" && "handleMount" in arg;
}

function getElement(arg: any): Element|null {
	if (arg instanceof Element) {
		return arg;
	}
	if (typeof arg === "object" && "element" in arg && arg.element instanceof Element) {
		return arg.element;
	}
	return null;
}


let loadEnvPromise: Promise<MyonEnv>|undefined;
const loadEnv = (envEndpoint: string): Promise<MyonEnv> => {
	if (loadEnvPromise) {
		return loadEnvPromise;
	}
	return loadEnvPromise = (async (): Promise<MyonEnv> => {
		const response = await fetch(envEndpoint);
		const json: MyonApiResponse<MyonEnv> = await response.json();
		if (!isMyonApiSuccess(json)) {
			throw new Error("No ENV loaded");
		}
		return json.result;
	})();
};

export async function run(
	envEndpoint: string,
	cacheBuster: string,
	path: string,
	args: any,
	languagePreloads: Record<string, { path: string & keyof MyonLanguageLoaderMap, data: any }>,
	insertBefore: Element|undefined,
): Promise<void> {

	const env = await loadEnv(envEndpoint);
	const langLoader = $getLanguageLoader(env);

	Object.entries(languagePreloads).forEach(([ key, { path, data }]) => {
		args[key] = langLoader.inject(path, data);
	});

	args["env"] = env;

	const moduleLoader = new ESModuleLoader({
		baseUrl: "./",
		urlArgs: cacheBuster
	});
	const bootstrapper = new Bootstrapper(moduleLoader, dependencyInjector);
	const app = await bootstrapper.bootstrap(path, args);

	if (!app) {
		return;
	}

	const element = getElement(app);
	if (element && insertBefore && insertBefore.parentElement) {
		insertBefore.parentElement.insertBefore(element, insertBefore);
	}

	if (isMountable(app)) {
		app.handleMount();
	}
}
